import React from "react"
import { connect } from "react-redux"
import { BtnPrimary } from "components/button"
import { Layout } from "Session"
import Modal from "components/modal"
import { endOfCurrentYear } from "helpers/time-formatter"
import { confirmCheckout } from "actions/checkout"

const OnboardingPaymentCreditcardWaitingCurrentYear = ({ currentUser, dispatch, requestInProgress }) => (
  <Layout>
    <Modal color="purple">
      <h2>Pedido realizado com sucesso!</h2>

      <p>
        Seu pedido foi realizado com sucesso e você já pode acessar a plataforma Mindzup. Seu pagamento ainda pode
        passar por análise. Caso ocorra algum problema, entraremos em contato com você por e-mail.
      </p>

      <p>Lembre-se: Seu acesso é válido até dia {endOfCurrentYear()}.</p>

      <BtnPrimary
        to="#"
        value="Iniciar"
        disabled={requestInProgress}
        arrow
        onClick={() => confirmCheckout(currentUser, dispatch)}
      />

      <div className="modal-link">
        Dúvidas?{" "}
        <a to="https://mlbr.com.br/meajuda" target="_blank" rel="noopener noreferrer">
          Fale com a gente no chat
        </a>
      </div>
    </Modal>
  </Layout>
)

const mapStateToProps = state => {
  return {
    currentUser: state.auth.currentUser,
    requestInProgress: state.http.requestInProgress
  }
}

export default connect(mapStateToProps)(OnboardingPaymentCreditcardWaitingCurrentYear)
